import React from "react";
import "./GroupTile.css";
import {GroupResponse} from "../logic/APITypes";
import {NameLogo} from "./NameLogo";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

const GroupTile = ({
  id,
  name,
  description,
  apps,
  admins,
  member_count,
  is_admin,
}: GroupResponse) => {
  return (
    <Link className="groupTile" to={"/groups/" + id} state={{from: "groups"}}>
      <div className="groupTile__row groupTile__title">
        <NameLogo text={name} id={id} size={48} />
        {name}
        {is_admin && (
          <span className="groupTile__admin">
            <FormattedMessage id="groupTile.admin" />
          </span>
        )}
      </div>
      <div className="groupTile__row">{description}</div>
      <div className="groupTile__row">
        <span>
          <b>
            <FormattedMessage id="groupTile.memberCount" />
          </b>
          {member_count}
        </span>
        <span>
          <b>
            <FormattedMessage id="groupTile.admins" />
          </b>
          {admins.length === 0 ? "—" : admins.join(", ")}
        </span>
      </div>
      <div className="groupTile__row">
        {apps.length === 0 ? (
          <i>
            <FormattedMessage id="groupTile.noApps" />
          </i>
        ) : (
          <span>
            <b>
              <FormattedMessage id="groupTile.apps" />
            </b>
            {apps.join(", ")}
          </span>
        )}
      </div>
    </Link>
  );
};

export {GroupTile as JoinedGroup};
